import './css/site.scss';
import 'bootstrap';
import 'whatwg-fetch';
import "babel-polyfill";
import Promise from 'promise-polyfill';
if (!window["Promise"]) {
    window["Promise"] = Promise;
}
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Layout } from './Components/Layout';
import {ClaimSelection} from "./Components/ClaimSelection";


function renderApp() {
    // This code starts up the React app when it runs in a browser. It sets up the routing
    // configuration and injects the app into a DOM element.
    ReactDOM.render(
        <div>
            <Layout>
                <ClaimSelection />
            </Layout>
        </div>,
        document.getElementById('claims-app')
    );
}

renderApp();

